<template>
  <div id="app" :class="['app ' + route.name]">
    <transition name="fade">
      <div id="page" class="page" v-if="pageLoaded">
        <transition name="fade">
          <Menu v-if="menuVisible" @scrollToSection="scrollToSection"/>
        </transition>
        <div
            class="mob menu-icon"
            @click="toggleMenu"
            :class="{ active: menuVisible }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="header-container">
          <Header
              :searchedProductText="searchedProductText"
              @openSignInModal="openSignInModal"
              @openSignUpModal="openSignUpModal"
              @logout="logout"
              @scrollToSection="scrollToSection"
          />
        </div>
        <router-view
            @logout="logout"
            @getProductPageContent="getProductPageContent"
            @formatDate="formatDate"
            :currency="internalCurrencyName"
            @goToProduct="goToProduct"
            :productPageItem="productPageItem"
            :models="models"
            @openReadyModal="openReadyModal"
            @openTopUpModal="openTopUpModal"
            @setModel="setModel"
            @setCategory="setCategory"
            @setCategory2="setCategory2"
            @openSignInModal="openSignInModal"
        />
        <div class="footer-container">
          <Footer
              v-if="
              isAuth ||
              (!isAuth && route.name != 'Profile' && route.name != 'Cart')
            "
              @scrollToSection="scrollToSection"
          />
        </div>
        <transition name="fade">
          <SignInModal
              v-if="signInModalIsVisible"
              @closeSignInModal="closeSignInModal"
              @openSignUpModal="openSignUpModal"
              @login="login"
              @forgotPass="forgotPass"
          />
        </transition>
        <transition name="fade">
          <SignUpModal
              v-if="signUpModalIsVisible"
              @closeSignUpModal="closeSignUpModal"
              @openSignInModal="openSignInModal"
              @registration="registration"
          />
        </transition>
        <transition name="fade">
          <TopUpModal
              v-if="topUpModalVisible"
              @openOrderModal="openOrderModal"
              :topUpAmount="topUpAmount"
              :itemType="itemType"
          />
        </transition>
        <transition name="fade">
          <OrderModal
              :orderData="orderData"
              v-show="orderModalIsVisible"
              @orderSubmit="orderSubmit"
          />
        </transition>
        <transition name="fade">
          <ReadyModal v-if="readyModalVisible"/>
        </transition>

        <div
            class="modal-overlay"
            v-if="cookesModalIsVisible && !isOnCookiePolicyPage"
        >
          <div class="cookies-modal">
            <div class="desc">
              {{
                $t(
                    `We use cookies on our website to enhance your experience. Before you proceed with using our Website, please get acquainted with the way we handle a User's data and the use of Usage of`
                )
              }}
              <a href="#" @click.prevent="goToPage('cookie-policy')">{{
                  $t(`cookie policy`)
                }}</a
              >.
            </div>
            <button class="button" @click="acceptCookies">
              {{ $t(`Accept`) }}
            </button>
            <button class="button" @click="declineCookies">
              {{ $t(`Reject`) }}
            </button>
          </div>
        </div>
      </div>
    </transition>

    <ChatBot/>
  </div>
</template>

<script setup>
import {ref, reactive, computed, onMounted, onBeforeUnmount, watch, provide} from "vue";
import {useRouter, useRoute} from "vue-router";
import {useStore} from "vuex";
import {useToast} from "vue-toastification";
import {scroller} from "vue-scrollto/src/scrollTo";
import axios from "@/axios";
import {rootInstance as rootAxios} from "@/axios";
import internalCurrencyImage from "@/img/internal-currency.png";
import Header from "./components/Header.vue";
import Menu from "./components/Menu.vue";
import Footer from "./components/Footer.vue";
import SignInModal from "./components/SignInModal.vue";
import SignUpModal from "./components/SignUpModal.vue";
import TopUpModal from "./components/TopUpModal.vue";
import ReadyModal from "./components/ReadyModal.vue";
import OrderModal from "./components/OrderModal.vue";
import ChatBot from "./components/ChatBot.vue";


const toast = useToast();
const router = useRouter();
const route = useRoute();
const store = useStore();

// state
const activeModel = ref("");
const activeCategory = ref("");
const activeCategory2 = ref("");
const dropdownCategories = ref([]);
const cookesModalIsVisible = ref(false);
const orderModalIsVisible = ref(false);
const availablePaymentMethods = ref([]);
const orderData = reactive({});
const packs = ref([]);
const activePack = reactive({});
const activePackProducts = ref("");
const menuVisible = ref(false);
const tranding = ref([]);
const readyProduct = reactive({});
const itemType = ref(null);
const readyModalVisible = ref(false);
const readyPromt = ref(false);
const readyPack = ref(false);

const buyProductLoading = ref(false);
const successMessage = ref("");
const error = ref("");

const topUpAmount = ref(0);
const topUpModalVisible = ref(false);
const hostname = ref("");
const imgDomain = ref("");
const appDomain = ref("");
const pageLoaded = ref(false);
const socialLinks = ref([]);
const textPageList = ref([]);
const textPageTitle = ref("");
const textPageContent = ref("");
const textPageHeader = ref("");
const settings = reactive({});
const internalCurrencyName = ref("IdeaCoins");
const exchangeRate = ref(0);
const orderHistory = ref([]);
const promtHistory = ref([]);
const depositHistory = ref([]);
const productPageType = ref("");
const models = ref([]);
const productPageItem = ref("");
const isValidEmail = ref(false);
const searchedProductText = ref("");

const isAuth = computed(() => store.getters["user/isAuth"]);
const currency = computed(() => store.getters["app/currency"]);
const currencySymbol = computed(() => store.getters["app/currencySymbol"]);
const isOnCookiePolicyPage = computed(() => route.path.includes("/pages/1"));
const fetchCurrencies = async () => {
  return await store.dispatch("app/fetchCurrencies")
};

provide("activePack", activePack);
provide("clearError", clearError);
provide("error", error);
provide("successMessage", successMessage);
provide("buyProductLoading", buyProductLoading);
provide("closeReadyModal", closeReadyModal);
provide("buyPack", buyPack);
provide("buyProduct", buyProduct);
provide("itemType", itemType);
provide("readyProduct", readyProduct);
provide("readyPromt", readyPromt);
provide("readyPack", readyPack);
provide("currency", currency);
provide("closeTopUpModal", closeTopUpModal);
provide("exchangeRate", exchangeRate);
provide("allPaymentMethods", availablePaymentMethods); // если allPaymentMethods отличается - объяви отдельно
provide("socialLinks", socialLinks);
provide("availablePaymentMethods", availablePaymentMethods);
provide("closeOrderModal", closeOrderModal);
provide("hostname", hostname);
provide("formatDate", formatDate); // formatDate функция, проверь что она объявлена
provide("depositHistory", depositHistory);
provide("orderHistory", orderHistory);
provide("promtHistory", promtHistory);
provide("logout", logout); // функция logout должна быть объявлена
provide("openTopUpModal", openTopUpModal);
provide("internalCurrencyImage", internalCurrencyImage); // должна быть объявлена
provide("internalCurrencyName", internalCurrencyName);
provide("getTextPageContent", getTextPageContent); // функция должна быть объявлена
provide("textPageTitle", textPageTitle);
provide("textPageHeader", textPageHeader);
provide("textPageContent", textPageContent);
provide("isAuth", isAuth);
provide("productPageType", productPageType);
provide("productPageItem", productPageItem);
provide("imgDomain", imgDomain);
provide("goToPage", goToPage); // функция должна быть объявлена
provide("setReadyPrompt", setReadyPromt);
provide("openReadyModal", openReadyModal);
provide("clearSearch", clearSearch);
provide("activeModel", activeModel);
provide("activeCategory", activeCategory);
provide("activeCategory2", activeCategory2);
provide("getPacks", getPacks);
provide("getTranding", getTranding);
provide("openSignInModal", openSignInModal);
provide("openSignUpModal", openSignUpModal);
provide("models", models); // models должен быть объявлен
provide("tranding", tranding);
provide("settings", settings);
provide("textPageList", textPageList);
provide('isOnCookiePolicyPage', isOnCookiePolicyPage)

function goToProduct(item) {
  productPageType.value = "";

  router.push({
    path: "/products/" + item.product_type + "/" + item.id,
    params: {data: item.id},
  });

  getProductPageContent(item.id);
  productPageType.value = item.product_type;
}

function getProductPageContent(id, type) {
  productPageItem.value = "";

  if (type) {
    if (type == "pack") {
      axios
          .get("packs/" + id + "/info")
          .then((res) => {
            productPageItem.value = res.data.payload;
          })
          .catch((res) => {
            if (res.response.status === 401) {
              openSignInModal();
            }
          });
    } else {
      axios
          .get("products/" + id + "/info")
          .then((res) => {
            productPageItem.value = res.data.payload;
          })
          .catch(() => {
          });
    }
  }
}

async function registration(data) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  isValidEmail.value = emailRegex.test(data.email);

  if (data.password !== data.passConfirm) {
    error.value = "Password confirmation failed!";
  } else if (!isValidEmail.value) {
    error.value = "Email format failed!";
  } else {
    axios
        .post("register", data)
        .then(async (res) => {
          if (res.data.status == "OK") {
            clearError();
            await store.dispatch("user/changeIsAuth", true);
            closeSignUpModal();
          } else {
            error.value = res.data.message;
          }
        })
        .catch((res) => {
          error.value = res.response.data.message;
        });
  }
}

function clearDropdownCategories() {
  dropdownCategories.value = [];
}

function openModelDropdown(model) {
  dropdownCategories.value = store.state.app.categories.filter(
      (item) => item.parent_id === model.id
  );
}

function clearSearch() {
  activeModel.value = "";
  activeCategory.value = "";
  activeCategory2.value = "";
}

function setModel(val) {
  activeModel.value = val;
}

function setCategory(val) {
  activeCategory.value = val;
}

function setCategory2(val) {
  activeCategory2.value = val;
}

function cookiesModal() {
  const cookiesAccepted = localStorage.getItem("cookiesAccepted");
  if (!cookiesAccepted) {
    cookesModalIsVisible.value = true;
  }
}

function declineCookies() {
  cookesModalIsVisible.value = false;
}

function acceptCookies() {
  localStorage.setItem("cookiesAccepted", "true");
  cookesModalIsVisible.value = false;
}

async function checkAuthStatus() {
  try {
    const res = await axios.get("is-auth");
    await store.dispatch("user/changeIsAuth", res.data.authenticated);
    await store.dispatch("user/changeEmailVerified", res.data.emailVerified);

    if (res.data.authenticated) {
      getOrderHistory();
      getPromtHistory();
      getDepositHistory();
    }

    if (res.data.authenticated && !res.data.emailVerified) {
      router.push({name: "EmailVerificationNotice"});
    }
  } catch (err) {
    if (err.response?.status === 401) {
      openSignInModal();
    }
  }
}

function goToPage(item) {
  let newItem;
  if (item == "privacy") {
    for (let i = 0; i < textPageList.value.length; i++) {
      if (textPageList.value[i].title.toLowerCase().includes("privacy")) {
        newItem = textPageList.value[i].id;
      }
    }
  } else if (item == "terms") {
    for (let i = 0; i < textPageList.value.length; i++) {
      if (textPageList.value[i].title.toLowerCase().includes("terms")) {
        newItem = textPageList.value[i].id;
      }
    }
  } else if (item === "cookie-policy") {
    for (let i = 0; i < textPageList.value.length; i++) {
      if (textPageList.value[i].title.toLowerCase().includes("cookie")) {
        newItem = textPageList.value[i].id;
        break;
      }
    }
  } else {
    newItem = item;
  }
  router.push({
    path: "/pages/" + newItem,
    params: {data: newItem},
  });
  getTextPageContent(newItem);
  closeSignUpModal();
}

function getTextPageContent(id) {
  textPageTitle.value = "";
  textPageHeader.value = "";
  textPageContent.value = "";

  axios
      .get("static-pages/" + id)
      .then((res) => {
        textPageTitle.value = res.data.payload.title;
        textPageContent.value = res.data.payload.content;
        textPageHeader.value = res.data.payload.header;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          openSignInModal();
        }
      });
}

async function orderSubmit(data, type) {
  data.paymentType = type;
  const apiUrl = data.itemType ? "deposit/bundle-checkout" : "deposit/checkout";

  try {
    const res = await axios.post(apiUrl, data);
    if (res.data.status === "ERROR") {
      router.push({name: "PaymentFaliPage"});
      orderModalIsVisible.value = false;
    } else {
      window.location = res.data.redirect_url;
    }
  } catch (err) {
    toast.warning(err.response.data.message, {timeout: 2000});
  }
}

function openOrderModal({orderData: data, paymentMethods}) {
  orderModalIsVisible.value = true;
  availablePaymentMethods.value = paymentMethods;
  Object.assign(orderData, data);
}

function closeOrderModal() {
  orderModalIsVisible.value = false;
}

async function getPacks() {
  packs.value = [];
  Object.keys(activePack).forEach(k => delete activePack[k]);
  try {
    const res = await axios.get("packs");
    packs.value = res.data.payload;
    if (packs.value.length > 0) {
      Object.assign(activePack, packs.value[0]);
      await getActivePackProducts(activePack);
    }
  } catch {
  }
}

async function getActivePackProducts(item) {
  try {
    const res = await axios.get("packs/" + item.id);
    Object.assign(activePack, item);
    activePackProducts.value = "";
    setTimeout(() => {
      activePackProducts.value = res.data.payload;
    }, 300);
  } catch {
  }
}

function logout() {
  axios
      .post("logout")
      .then(async () => {
        if (route.name != "Home") {
          router.push({path: "/"});
        }

        await store.dispatch("user/changeIsAuth", false);
      })
      .catch((res) => {
        if (res.response.status === 401) {
          openSignInModal();
        }
      });
}

function scrollToSection(section) {
  if (route.name !== "Home" && section !== "page") {
    router.push({path: "/"});
  } else {
    closeMenu();
  }

  setTimeout(() => {
    const firstScrollTo = scroller();
    firstScrollTo("#" + section, 1000);
  }, 1000);
}

function formatDate(num) {
  let objectDate = new Date(num);
  let day = objectDate.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  let month = objectDate.getMonth() + 1;
  if (month < 10) {
    month = `0${month}`;
  }
  let year = objectDate.getFullYear();

  function padTo2Digits(x) {
    return String(x).padStart(2, "0");
  }

  let hoursAndMinutes =
      padTo2Digits(objectDate.getHours()) +
      ":" +
      padTo2Digits(objectDate.getMinutes());
  let format = day + "." + month + "." + year + " " + hoursAndMinutes;

  return format;
}

async function getTranding() {
  tranding.value = [];
  try {
    const res = await axios.get("products/trending");
    tranding.value = res.data.payload;
  } catch {
  }
}

async function buyPack() {
  let data = {
    pack_id: readyProduct.id,
  };

  try {
    buyProductLoading.value = true;
    const res = await axios.post("purchase/pack", data);
    if (res.data.status === "OK") {
      successMessage.value = "Thank you for your purchase!\n\nYour prompt can be found on 'My prompts' tab";
      router.push({path: "/profile/order-history"});
    } else {
      error.value = res.data.message;
    }
  } catch (err) {
    error.value = err.response.data.message;
  } finally {
    buyProductLoading.value = false;
  }
}

async function topUpSubmit(data) {
  try {
    const res = await axios.post("deposit/checkout", data);
    if (res.data.status === "OK") {
      window.location = res.data.redirect_url;
    } else {
      error.value = res.response.data.message;
    }
  } catch (err) {
    error.value = err.response.data.message;
    if (err.response?.status === 401) {
      openSignInModal();
    }
  }
}

async function buyProduct() {
  let data = {
    prompt_id: readyProduct.id,
  };

  try {
    buyProductLoading.value = true;

    const res = await axios.post("purchase/prompt", data);
    if (res.data.status === "OK") {
      successMessage.value =
          "Thank you for your purchase!\n\nYour prompt can be found on 'My prompts' tab";
      router.push({path: "/profile/order-history"});
    } else {
      error.value = res.data.message;
    }
  } catch (err) {
    error.value = err.response.data.message;
  } finally {
    buyProductLoading.value = false;
  }
}

function openReadyModal(itemTypeVal, product) {
  Object.assign(readyProduct, product);
  itemType.value = itemTypeVal;
  if (itemTypeVal === "pack") {
    setReadyPack();
  } else {
    setReadyPromt();
  }
  readyModalVisible.value = true;
}

function setReadyPromt() {
  readyPromt.value = true;
  readyPack.value = false;
}

function setReadyPack() {
  readyPack.value = true;
  readyPromt.value = false;
}

function closeReadyModal() {
  readyPromt.value = false;
  readyPack.value = false;
  successMessage.value = "";
  error.value = "";
  readyModalVisible.value = false;
}

function openTopUpModal(amount = 0.0, itemTypeVal = null) {
  topUpAmount.value = amount;
  topUpModalVisible.value = true;
  itemType.value = itemTypeVal;
}

function closeTopUpModal() {
  topUpAmount.value = 0;
  topUpModalVisible.value = false;
}

function getDomainName(hostName) {
  return hostName.substring(
      hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1
  );
}

function toggleMenu() {
  menuVisible.value = !menuVisible.value;
  window.scrollTo(0, 0);
  if (menuVisible.value) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
}

function menuHeight() {
  const doc = document.documentElement;
  doc.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
}

function openSignInModal() {
  closeMenu();
  clearError();
  signUpModalIsVisible.value = false;
  signInModalIsVisible.value = true;
}

function openSignUpModal() {
  clearError();
  signInModalIsVisible.value = false;
  signUpModalIsVisible.value = true;
}

function clearError() {
  error.value = "";
}

function closeSignUpModal() {
  signUpModalIsVisible.value = false;
  clearError();
}

function closeSignInModal() {
  signInModalIsVisible.value = false;
  clearError();
}

const signInModalIsVisible = ref(false);
const signUpModalIsVisible = ref(false);

async function login(data) {
  try {
    await fetchCSRFToken();

    const res = await axios.post("login", data);

    if (res.data.status === "OK") {
      await store.dispatch("user/changeIsAuth", true);
      await store.dispatch(
          "user/changeEmailVerified",
          !!res.data.payload.email_verified
      );
      closeSignInModal();
      getOrderHistory();
      getPromtHistory();
      getDepositHistory();
    } else {
      error.value = res.data.message;
    }
  } catch (err) {
    if (err.response) {
      error.value = err.response.data.message;
    } else {
      error.value = "An error occurred during login.";
    }
  }
}

async function fetchCSRFToken() {
  try {
    await rootAxios.get("sanctum/csrf-cookie");
  } catch (err) {
    console.error("Failed to fetch CSRF token:", err);
  }
}

async function fetchSocialLinks() {
  axios
      .get("social-links")
      .then(({data}) => {
        socialLinks.value = data.payload;
      })
      .catch((error) => {
        console.log(error);
      });
}

async function fetchTextPages() {
  axios
      .get("static-pages")
      .then((res) => {
        textPageList.value = res.data.payload;
      })
      .catch(() => {});
}

async function forgotPass(data) {
  try {
    const res = await axios.post("user/reset-password", data);
    if (res.data.status === "OK") {
      successMessage.value = res.data.message;
      error.value = "";
      setTimeout(() => {
        successMessage.value = "";
      }, 2000);
    } else {
      successMessage.value = "";
      error.value = res.data.message;
    }
  } catch (err) {
    error.value = err.response.data.message || "Error during password reset.";
  }
}

async function resetPassword(data) {
  try {
    const res = await axios.post("user/reset-password-form", data);
    if (res.data.status === "OK") {
      successMessage.value = res.data.message;
      error.value = "";
      setTimeout(() => {
        successMessage.value = "";
      }, 2000);
    } else {
      successMessage.value = "";
      error.value = res.data.message;
    }
  } catch (err) {
    error.value = err.response.data.message || "Error during password reset.";
  }
}

async function checkEmail(email) {
  try {
    const res = await axios.get("user/check-email/" + email);
    isValidEmail.value = res.data.payload.isValid;
  } catch {
    isValidEmail.value = false;
  }
}

async function getOrderHistory() {
  try {
    const res = await axios.get("purchase/history");
    orderHistory.value = res.data.payload;
  } catch {
  }
}

async function getPromtHistory() {
  try {
    const res = await axios.get("user/prompts");
    promtHistory.value = res.data.payload;
  } catch {
  }
}

async function getDepositHistory() {
  try {
    const res = await axios.get("deposit/history");
    depositHistory.value = res.data.payload;
  } catch {
  }
}

async function getSettings() {
  try {
    const res = await axios.get("settings");
    Object.assign(settings, res.data.payload);
    if (settings.internal_currency_name) {
      internalCurrencyName.value = settings.internal_currency_name;
    }
    if (settings.exchange_rate) {
      exchangeRate.value = parseFloat(settings.exchange_rate);
    }
  } catch {
  }
}

function closeMenu() {
  menuVisible.value = false;
  document.body.style.overflow = "auto";
}

onMounted(() => {
  menuHeight();
  window.addEventListener("resize", menuHeight);
  cookiesModal();
  hostname.value = window.location.hostname;
  imgDomain.value = process.env.VUE_APP_STATIC_DOMAIN;
  appDomain.value = window.location.hostname;
  pageLoaded.value = true;

  fetchCurrencies()
  fetchSocialLinks()
  fetchTextPages()
  getSettings();
  getPacks();
  getTranding();

  checkAuthStatus();

  // Можно добавить другие нужные вызовы
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", menuHeight);
});
</script>

